<template lang="pug">
  .main-content.bg-default(style="min-height: 1300px")
    .header.bg-gradient-info.py-7
      .separator.separator-bottom.separator-skew.zindex-100
        svg(x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg")
        polygon.fill-default(points="2560 0 2560 100 0 100")
    .container.mt--8
      slide-y-up-transition(mode="out-in" origin="center top")
        router-view
      //- router-link(to="/ecommerce")
      //-   h4.text-light.text-center.mt-4 {{ $t("back_to_top") }}
      .copyright.text-center.text-xl-center.text-muted.mt-4
        p.ml-1
          span.text-primary.font-weight-bold M2M © {{ year }}
</template>
<script>
import { SlideYUpTransition } from "vue2-transitions";
export default {
  name: "auth-layout",
  components: {
    SlideYUpTransition,
  },
  data() {
    return {
      year: new Date().getFullYear(),
      showMenu: false,
    };
  },
};
</script>